/* eslint-disable no-console */

import { register } from "register-service-worker";
import {logValuesInSession} from "./shared/utils";
// eslint-disable-next-line
register(`${process.env.BASE_URL}service-worker.js`, {
  // registrationOptions: { scope: './' },
  // eslint-disable-next-line
  ready(registration) {
    logValuesInSession('service_worker', "Service worker is active.");
  },
  registered(registration) {
    logValuesInSession('service_worker_registered', registration);
    setInterval(() => {
      registration.update();
    }, 3000);
  },
  // eslint-disable-next-line
  cached(registration) {
    logValuesInSession('service_worker_content', "Content has been cached for offline use.");
  },
  // eslint-disable-next-line
  updatefound(registration) {
    logValuesInSession('service_worker_new_content', "New content is downloading.");
  },
  // eslint-disable-next-line
  updated(registration) {
    window.location.reload(true);
  },
  offline() {
    logValuesInSession('service_worker_offline', "No internet connection found. App is running in offline mode.");
    
  },
  error(error) {
    logValuesInSession('service_worker_error', error);    
  }
});
